import * as React from 'react';
import { ElementLoader, PromptConfirmation } from 'ui';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { ChangeOwnerComponentProps, ChangeOwnerField } from 'app/area/favourite-administration/list/change-owner/types';
import { allFieldsEmpty, hasFieldValueChanged, isDisabled } from 'app/area/favourite-administration/list/change-owner/change-owner-helpers';
import { Owner } from 'app/area/favourite-administration/list/change-owner/owner';
import { ReplaceWithOwners } from 'app/area/favourite-administration/list/change-owner/replace-with-owners';
import { ApplyOnDescendants } from 'app/area/favourite-administration/list/components/apply-on-descendants';
import styles from './change-owner.scss';

interface ChangeOwnerComponentState {
  shouldDisplayModal: boolean;
}

export class ChangeOwnerModal extends React.PureComponent<ChangeOwnerComponentProps, ChangeOwnerComponentState> {

  constructor(props: ChangeOwnerComponentProps) {
    super(props);

    this.state = {
      shouldDisplayModal: undefined
    };
  }

  public componentDidUpdate(prevProps: ChangeOwnerComponentProps) {
    this.handleIsDirty(prevProps);
  }

  private handleIsDirty = (prevProps: ChangeOwnerComponentProps) => {
    hasFieldValueChanged(prevProps, this.props) && this.props.updateIsDirty(true);
  };

  private toggleModal = () => {
    this.setState({ shouldDisplayModal: !this.state.shouldDisplayModal });
  };

  private continue = () => {
    this.toggleModal();
    this.props.save();
    this.props.updateIsDirty(false);
  };

  private onClose = () => {
    this.props.onClose();
    this.props.updateIsDirty(false);
  };

  private onApplyOnDescendants = (value: number) => {
    this.props.updateByKey(ChangeOwnerField.applyOnDescendants, !!value);
  };

  public render() {
    const { list: { changeOwner: { form } = {}, numberOfResults, fetchingChangeOwner }, translation } = this.props;

    return (<>
      <ModalWrapper
        headerTitle={`${translation.change_owner} (${numberOfResults})`}
        btnTitle={translation.change_owner}
        btnCancelTitle={translation.cancel}
        onClose={this.onClose}
        onDone={this.toggleModal}
        closeOnDone={false}
        isCancelDisabled={fetchingChangeOwner}
        isDisabled={fetchingChangeOwner || allFieldsEmpty(this.props) || isDisabled(this.props)}
        canCloseOnBackground={!fetchingChangeOwner}
        canCloseOnXButton={!fetchingChangeOwner}>

        {fetchingChangeOwner
          ? <ElementLoader />
          : <div>
            <p className={`${styles.changeOwnerText} mb-3`}>
              {translation.change_owner_description}
            </p>

            <div className="row">
              <div className="col-12">
                <Owner {...this.props} />
                <ReplaceWithOwners {...this.props} />
                <ApplyOnDescendants
                  value={form?.[ChangeOwnerField.applyOnDescendants]}
                  onChange={this.onApplyOnDescendants}
                  translation={translation} />
              </div>
            </div>
          </div>}
      </ModalWrapper>

      {this.state.shouldDisplayModal && <PromptConfirmation
        title={translation.change_owner}
        description={translation.change_owner_confirmation_description}
        continueText={translation.change_owner}
        cancelText={translation.cancel}
        onContinue={this.continue}
        onCancel={this.toggleModal}
      />}
    </>);
  }
}
